import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { GeneralErrorBannerService } from './general-error-banner.service';

/**
 * App-wide banner shown at the top of the screen when a save/validation event
 * fails (AC5). Bind it once near the top of a record form; it displays whenever
 * {@link GeneralErrorBannerService.show} is called and hides on dismiss/clear.
 */
@Component({
  selector: 'app-general-error-banner',
  templateUrl: './general-error-banner.component.html',
  styleUrls: ['./general-error-banner.component.scss']
})
export class GeneralErrorBannerComponent {
  readonly message$: Observable<string | null>;

  constructor(private readonly bannerService: GeneralErrorBannerService) {
    this.message$ = this.bannerService.message$;
  }

  close(): void {
    this.bannerService.clear();
  }
}
